import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {goToPage, setSelectedAddress, setIsSubmit, setIsValid, checkCellcomEnergy} from '../cellcomEnergySlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';

const AddressPage = (props) => {
  const innerBoxTitle = 'מהי הכתובת שלך';

  return (
    <div className='cellcom-energy-page-wrapper'>
      <div className='cellcom-energy-header'>
        <div className='header-title'>בואו נראה האם ניתן לנייד אתכם ל{window.Config.brand_Name_HE} Energy</div>
      </div>

      <div className='cellcom-energy-page'>
        <div>
          <AddressFrm onError={handleOnError} title={innerBoxTitle} onValid={handleAddressValidate} onSubmit={props.isSubmit} />
        </div>
        <div className='btn-wrapper'>
          <BtnSubmit text={'נתחיל בבדיקה'} onclick={handleAddressPageContinue} />
        </div>
      </div>
    </div>
  );

  function handleAddressPageContinue() {
    props.setIsSubmit(true);
  }

  function handleAddressValidate(valid) {
    if (valid) {
      handleAddressPageContinueAfterValid();
    }
    props.setIsSubmit(false);
  }

  function handleAddressPageContinueAfterValid() {
    const address = {
      cityCode: props._address.city,
      cityName: props._address.cityName,
      streetCode: props._address.street,
      streetName: props._address.streetName,
      houseNum: props._address.home,
    };
    props.setSelectedAddress(address);
    props.checkCellcomEnergy(address);
  }

  function handleOnError(errorId) {
    props.goToPage('errorPage');
    //props.setError({ isDisplay: true, id: errorId, isOpenWorkOrder: true });
  }
};

const mapStateToProps = (state) => {
  return {
    page: state.cellcomEnergyBlock.page,
    isSubmit: state.cellcomEnergyBlock.isSubmit,
    isValid: state.cellcomEnergyBlock.isValid,

    //other states
    _address: state.addressForm.form,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedAddress,
  setIsSubmit,
  setIsValid,
  checkCellcomEnergy,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
